<div class="ap-margin-bottom-3">
    {{ 'financial-obligations.payment-account-overdraft.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>
<ap-amount-input
    id="paymentAccountOverdraftAmount"
    [helpText]="'financial-obligations.payment-account-overdraft.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
></ap-amount-input>

<additional-info
    [key]="questionKey"
    titleKey="financial-obligations.payment-account-overdraft.amount.additional-info.title"
    contentKey="financial-obligations.payment-account-overdraft.amount.additional-info.content"
    modalUrlKey="financial-obligations.payment-account-overdraft.amount.additional-info.url-text"
></additional-info>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
